import {
  RCPT_FREE_DATA,
  RCPT_GET_RCPT_STATUS_LIST,
  RCPT_GET_RCPT_TYPES_LIST,
  RCPT_GET_RCPT_PROPERTIES,
  RCPT_GET_ROUTE,
  RCPT_GET_RECEPTURES_LIST, // Получение списка смесей, согласно установленному текущему фильтру
  RCPT_GET_RECEPTURE, // Получение рецептуры, по передаваемому идентификатору
  RCPT_SET_FILTER,
  RCPT_SET_CURRENT,
  RCPT_CREATE_RECEPTURE,
  RCPT_UPDATE,
  RCPT_POST_STATE,
  RCPT_ADD_FILE,
  RCPT_DEL_FILE,
  RCPT_GET_COMPONENTS,
  RCPT_GET_COMP_PROPERTIES,
  RCPT_GET_GOST_LIST,
  RCPT_GET_GOST_GRADES_LIST,
  RCPT_CHANGE_MESSAGE,
  RCPT_DEL_MESSAGE
} from '../actions/receptures'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import axios from 'axios'
const state = {
  currentRecepture: {},
  currentReceptureMessages: [],
  rcptList: [],
  rcptStatesList: [],
  rcptTypesList: [],
  currentRcptFilter: { DS_ID: '-5', FT_ID: '-5' }
}

const getters = {
  getCurrentReceptureState: state => state.currentRecepture.DS_ID,
  getCurrentReceptureID: state => state.currentRecepture.UFLT_ID,
  getCurrentRecepture: state => state.currentRecepture,
  getCurrentReceptureMessages: state => state.currentReceptureMessages,
  getCurrentReceptureComment: state => state.currentRecepture.ULF_COMMENT,
  getCurrentReceptureFiles: state => {
    if (typeof state.currentRecepture.FILE_LIST !== 'undefined') {
      return state.currentRecepture.FILE_LIST
    } else {
      return []
    }
  },
  getCurrentReceptureComponents: state => {
    if (typeof state.currentRecepture.COMPONENTS !== 'undefined') {
      return state.currentRecepture.COMPONENTS
    } else {
      return []
    }
  },
  getCurrentReceptureAvailStates: state => {
    if (typeof state.currentRecepture.AVAIL_STATUS !== 'undefined') {
      return state.currentRecepture.AVAIL_STATUS
    } else {
      return []
    }
  },
  getCurrentReceptureAvailReports: state => state.currentRecepture.AVAIL_REPORTS,
  getCurrentRecepturesList: state => state.rcptList,
  getRecepturesStatesList: state => state.rcptStatesList,
  getRecepturesTypesList: state => state.rcptTypesList,
  getCurrentRecepturesFilter: state => state.currentRcptFilter,
  getCurrentRecepturesStateFilter: state => state.currentRcptFilter.DS_ID,
  getCurrentRecepturesTypeFilter: state => state.currentRcptFilter.FT_ID
}

const actions = {
  [RCPT_FREE_DATA]: ({ commit }) =>
    new Promise((resolve) => {
      commit(RCPT_FREE_DATA)
      resolve('success')
    }),

  [RCPT_GET_RCPT_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_RCPT_STATUS_LIST', topic: 'Загрузка списка статусов рецептур', error: null })
      axios({ url: '/api/org/receptures/rcptStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_RCPT_STATUS_LIST' })
            commit(RCPT_GET_RCPT_STATUS_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            console.log('EVENT status list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'RCPT_GET_RCPT_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_RCPT_STATUS_LIST', result: 'Получение списка возможных статусов рецептуры: ошибка сервера' })
          reject(err)
        })
    }),

  [RCPT_GET_RCPT_TYPES_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_RCPT_TYPES_LIST', topic: 'Загрузка списка типов рецептур', error: null })
      axios({ url: '/api/org/receptures/rcptTypesList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_RCPT_TYPES_LIST' })
            commit(RCPT_GET_RCPT_TYPES_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_RCPT_TYPES_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_RCPT_TYPES_LIST', result: 'Получение списка возможных типов рецептуры: ошибка сервера' })
          reject(err)
        })
    }),

  [RCPT_GET_RCPT_PROPERTIES]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_RCPT_PROPERTIES', topic: 'Загрузка списка свойств рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptGetRcptProps.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_RCPT_PROPERTIES' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_RCPT_PROPERTIES', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_RCPT_PROPERTIES', result: 'Получение списка свойств рецептуры: ошибка сервера' })
          reject(err)
        })
    }),

  [RCPT_GET_ROUTE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_ROUTE', topic: 'Получение истории', error: null })
      axios({ url: '/api/org/receptures/getRcptRoute.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_ROUTE' })
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_ROUTE', result: 'Ошибка получения истории: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_ROUTE', result: 'Получение истории: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_GET_GOST_LIST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_GOST_LIST', topic: 'Загрузка списка ГОСТов для типа рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptGOSTList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_GOST_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_GOST_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_GOST_LIST', result: 'Получение списка ГОСТов для типа рецептуры: ошибка сервера' })
          reject(err)
        })
    }),

  [RCPT_GET_GOST_GRADES_LIST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_GOST_GRADES_LIST', topic: 'Получение списка топлив для ГОСТ', error: null })
      axios({ url: '/api/org/receptures/rcptGOSTGradesList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_GOST_GRADES_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_GOST_GRADES_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_GOST_GRADES_LIST', result: 'Получение списка топлив для ГОСТ: ошибка сервера' })
          reject(err)
        })
    }),

  [RCPT_GET_RECEPTURES_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_RECEPTURES_LIST', topic: 'Загрузка списка смесей', error: null })
      console.log('Called action RCPT_GET_RECEPTURES_LIST, current filter is  ', state.currentRcptFilter)
      const filterSet = !(state.currentRcptFilter.DS_ID === null)
      if (!filterSet) {
        reject(new Error('Не установлен фильтр состояний'))
        dispatch(UI_ERROR, { action: 'RCPT_GET_RECEPTURES_LIST', result: 'Не установлен фильтр состояний' })
        return
      }
      axios({ url: '/api/org/receptures/rcptGetList.php', data: state.currentRcptFilter, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_GET_RECEPTURES_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_RECEPTURES_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_RECEPTURES_LIST', result: 'Ошибка получения списка рецептур ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_RECEPTURES_LIST', result: 'Получение списка рецептур: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_GET_RECEPTURE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_RECEPTURE', topic: 'Загрузка рецептуры', error: null })
      axios({ url: '/api/org/receptures/getRecepture.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_RECEPTURE' })
            commit(RCPT_SET_CURRENT, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_RECEPTURE', result: 'Ошибка получения данных: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_RECEPTURE', result: 'Получение данных: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_GET_COMPONENTS]: ({ commit, dispatch }, recepture) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_COMPONENTS', topic: 'Получение списка компонентов рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptGetRcptComponents.php', data: recepture, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_COMPONENTS' })
            commit(RCPT_GET_COMPONENTS, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_COMPONENTS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_COMPONENTS', result: err })
          reject(new Error(err))
        })
    }),

  [RCPT_GET_COMP_PROPERTIES]: ({ commit, dispatch }, component) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_GET_COMP_PROPERTIES', topic: 'Получение списка свойств компонента рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptGetCompProps.php', data: component, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'RCPT_GET_COMP_PROPERTIES' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_GET_COMP_PROPERTIES', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_GET_COMP_PROPERTIES', result: err })
          reject(new Error(err))
        })
    }),

  [RCPT_SET_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action RCPT_SET_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'RCPT_SET_FILTER', topic: 'Установка фильтра рецептур', error: null })
      if (filterItem.DS_ID || filterItem.FT_ID) {
        if (filterItem.DS_ID !== state.currentRcptFilter.DS_ID || filterItem.FT_ID !== state.currentRcptFilter.FT_ID) {
          commit(RCPT_SET_FILTER, filterItem)
          dispatch(RCPT_GET_RECEPTURES_LIST)
            .then(resp => {
              dispatch(UI_SUCCESS, { action: 'RCPT_SET_FILTER' })
              resolve(resp)
            })
            .catch((err) => {
              dispatch(UI_ERROR, { action: 'RCPT_SET_FILTER', result: 'Установка фильтра рецептур: ошибка сервера' })
              reject(err)
            })
        } else {
          dispatch(UI_SUCCESS, { action: 'RCPT_SET_FILTER' })
          resolve(filterItem)
        }
      } else {
        commit(RCPT_SET_FILTER, filterItem)
        dispatch(UI_SUCCESS, { action: 'RCPT_SET_FILTER' })
        resolve(filterItem)
      }
    }),

  [RCPT_SET_CURRENT]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve) => {
      console.log('Called action RCPT_SET_CURRENT ', requestItem)
      dispatch(UI_REQUEST, { action: 'RCPT_SET_CURRENT', topic: 'Установка активной рецептуры', error: null })
      if (requestItem) {
        if (requestItem.ULF_ID !== state.currentRecepture.ULF_ID) {
          console.log('Setting new current recepture', requestItem)
          commit(RCPT_SET_CURRENT, requestItem)
        }
      } else {
        commit(RCPT_SET_CURRENT, {})
      }
      dispatch(UI_SUCCESS, { action: 'RCPT_SET_CURRENT' })
      resolve()
    }),

  [RCPT_CREATE_RECEPTURE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_CREATE_RECEPTURE', topic: 'Создание заголовка рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptAdd.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_CREATE_RECEPTURE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_CREATE_RECEPTURE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_CREATE_RECEPTURE', result: 'Создание заголовка рецептуры: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_CREATE_RECEPTURE', result: 'Создание заголовка рецептуры: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_UPDATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_UPDATE', topic: 'Создание заголовка рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptUpdate.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_UPDATE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_UPDATE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_UPDATE', result: 'Создание заголовка рецептуры: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_UPDATE', result: 'Создание заголовка рецептуры: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_POST_STATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_POST_STATE', topic: 'Изменение состояния рецептуры', error: null })
      axios({ url: '/api/org/receptures/rcptPostState.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_POST_STATE, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_POST_STATE' })
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_POST_STATE', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_POST_STATE', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_ADD_FILE,', topic: 'Добавление файла к рецептуре', error: null })
      axios({ url: '/api/org/receptures/rcptUploadDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_ADD_FILE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_ADD_FILE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_ADD_FILE', result: 'Ошибка добавления файла в запрос: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_ADD_FILE', result: 'Добавление данных в запрос: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [RCPT_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_DEL_FILE', topic: 'Удаление файла из запроса', error: null })
      axios({ url: '/api/org/receptures/rcptDeleteDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_DEL_FILE, params)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_DEL_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_DEL_FILE', result: 'Удаление файла из запроса: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_DEL_FILE', result: 'Удаление файла из запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [RCPT_CHANGE_MESSAGE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_CHANGE_MESSAGE', topic: 'Добавление сообщения к конфигурации', error: null })
      axios({ url: '/api/org/receptures/rcptChangeMessage.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_CHANGE_MESSAGE, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_CHANGE_MESSAGE' })
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_CHANGE_MESSAGE', result: 'Добавление сообщения к конфигурации: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_CHANGE_MESSAGE', result: 'Добавление сообщения к конфигурации: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [RCPT_DEL_MESSAGE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'RCPT_DEL_MESSAGE', topic: 'Удаление сообщения из конфигурации', error: null })
      axios({ url: '/api/org/receptures/rcptDeleteMessage.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(RCPT_CHANGE_MESSAGE, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'RCPT_DEL_MESSAGE' })
          } else {
            dispatch(UI_ERROR, { action: 'RCPT_DEL_MESSAGE', result: 'Удаление сообщения из конфигурации: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'RCPT_DEL_MESSAGE', result: 'Удаление сообщения из конфигурации: ошибка сервера' })
          reject(new Error(err))
        })
    })
}

const mutations = {

  [RCPT_FREE_DATA]: state => {
    state.currentRecepture = {}
    state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length)
    state.rcptList.splice(0, state.rcptList.length)
    state.rcptStatesList.splice(0, state.rcptStatesList.length)
    state.rcptTypesList.splice(0, state.rcptTypesList.length)
    state.currentRcptFilter = { DS_ID: '-5', FT_ID: '-5' }
  },

  [RCPT_GET_RCPT_STATUS_LIST]: (state, resp) => {
    console.log('RCPT_GET_RCPT_STATUS_LIST mutation initiated, ', resp)
    state.rcptStatesList.splice(0, state.rcptStatesList, ...resp)
    state.currentRcptFilter.DS_ID = state.rcptStatesList[0].DS_ID
  },

  [RCPT_GET_RCPT_TYPES_LIST]: (state, resp) => {
    console.log('RCPT_GET_RCPT_TYPES_LIST mutation initiated, ', resp)
    state.rcptTypesList.splice(0, state.rcptTypesList, ...resp)
  },

  [RCPT_GET_RECEPTURES_LIST]: (state, resp) => {
    console.log('RCPT_GET_RECEPTURES_LIST mutation initiated, ', resp)
    state.rcptList.splice(0, state.rcptList.length, ...resp)
    state.currentRecepture = {}
    state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length)
  },
  [RCPT_SET_FILTER]: (state, resp) => {
    console.log('RCPT_SET_FILTER mutation initiated, ', resp)
    state.currentRcptFilter = { ...state.currentRcptFilter, ...resp }
  },

  [RCPT_SET_CURRENT]: (state, resp) => {
    console.log('RCPT_SET_CURRENT mutation initiated, ', resp)
    state.currentRecepture = resp
    const comments = resp.COMMENTS_TAB ? resp.COMMENTS_TAB : []
    state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length, ...comments)
  },

  [RCPT_GET_COMPONENTS]: (state, resp) => {
    console.log('RCPT_GET_COMPONENTS mutation initiated, ', resp)
    if (typeof state.currentRecepture.COMPONENTS !== 'undefined') {
      state.currentRecepture.COMPONENTS.splice(0, state.currentRecepture.COMPONENTS.length, ...resp)
    } else {
      state.currentRecepture.COMPONENTS = resp
    }
  },

  [RCPT_CREATE_RECEPTURE]: (state, rcptItem) => {
    console.log('RCPT_CREATE_RECEPTURE mutation initiated', rcptItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    // eslint-disable-next-line eqeqeq
    if (state.currentRcptFilter.DS_ID == rcptItem.STATE.DS_ID || state.currentRcptFilter.DS_ID == -5) {
      // Если да, то добавляем новый запрос в глобальный список запросов
      state.rcptList.push(rcptItem)
    }
    state.currentRecepture = rcptItem
    state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length, ...rcptItem.COMMENTS_TAB)
  },

  [RCPT_UPDATE]: (state, rcptItem) => {
    console.log('RCPT_UPDATE mutation initiated', rcptItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    // eslint-disable-next-line eqeqeq
    if (state.currentRcptFilter.DS_ID == rcptItem.STATE.DS_ID || state.currentRcptFilter.DS_ID == -5) {
      const idx = state.rcptList.findIndex(itm => itm.ULF_ID === rcptItem.ULF_ID)
      if (idx >= 0) {
        state.rcptList.splice(idx, 1, rcptItem)
      } else {
        state.rcptList.push(rcptItem)
      }
      state.currentRecepture = rcptItem
      state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length, ...rcptItem.COMMENTS_TAB)
    }
    state.currentRecepture = rcptItem
    state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length, ...rcptItem.COMMENTS_TAB)
  },

  [RCPT_POST_STATE]: (state, resp) => {
    console.log('RCPT_POST_STATE mutation called. RESP is ', resp)
    const rcptItemIdx = state.rcptList.findIndex(rcpt => rcpt.ULF_ID === resp.ULF_ID)
    if (state.currentRcptFilter.DS_ID !== resp.DS_ID && state.currentRcptFilter.DS_ID !== '-5') {
      if (rcptItemIdx >= 0) state.rcptList.splice(rcptItemIdx, 1)
    } else {
      if (rcptItemIdx >= 0) {
        state.rcptList[rcptItemIdx].STATE.DS_ID = resp.DS_ID
        state.rcptList[rcptItemIdx].STATE.DS_NAME = resp.DS_NAME
      }
    }
  },
  [RCPT_ADD_FILE]: (state, responce) => {
    console.log('RCPT_ADD_FILE mutation called, payload ', responce)
    // state.currentEvent.FILE_LIST.push(responce)
  },
  [RCPT_DEL_FILE]: (state, responce) => {
    console.log('RCPT_DEL_FILE mutation called, payload ', responce)
    // const index = state.currentEvent.FILE_LIST.findIndex(itm => itm.DD_ID === responce.DD_ID)
    // state.currentEvent.FILE_LIST.splice(index, 1)
  },
  [RCPT_CHANGE_MESSAGE]: (state, responce) => {
    console.log('RCPT_CHANGE_MESSAGE mutation called, payload ', responce)
    if (state.currentRecepture) {
      state.currentReceptureMessages.splice(0, state.currentReceptureMessages.length, ...responce)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
